export const textFieldRequired = (value: any) =>
  (value && value !== "") || value === 0 ? undefined : "Required";
